import { useEffect, useState } from "react";
import { safeAccountPhotoUrl } from "../lib/accountPhoto.js";

export function useAccountPhoto(identity, photoUrl) {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [identity, photoUrl]);
  return {
    photoSrc: failed ? null : safeAccountPhotoUrl(photoUrl),
    onPhotoError: () => setFailed(true),
  };
}
